import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { StatsStrip } from './components/sections/StatsStrip';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { ForYou } from './components/sections/ForYou';
import { Manuals } from './components/sections/Manuals';
import { Included } from './components/sections/Included';
import { AlwaysWithYou } from './components/sections/AlwaysWithYou';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Testimonials } from './components/sections/Testimonials';
import { Guarantee } from './components/sections/Guarantee';
import { WhyWeCreated } from './components/sections/WhyWeCreated';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full min-h-full bg-ink" data-id="element-0" data-mp="3mljaezbgzl56">
      <MetaPixel data-id="element-1" data-mp="3mk85uxa7a9d0" />
      <main className="w-full" data-id="element-2" data-mp="3mjq27fl7ksv2">
        <Hero data-id="element-3" data-mp="3rc9ca2kot5v4" />
        <StatsStrip data-id="element-4" data-mp="3rbrakqf99zft" />
        <BeforeAfter data-id="element-5" data-mp="3rdar8i4tqci4" />
        <ForYou data-id="element-6" data-mp="3rd1bdndhtlq5" />
        <Manuals data-id="element-7" data-mp="3recc1ebn6dd1" />
        <Included data-id="element-8" data-mp="5ygolyg4xb6" />
        <AlwaysWithYou data-id="element-9" data-mp="67z9oh5w26u" />
        <Bonuses data-id="element-10" data-mp="4n6o4eeqtbm" />
        <Offer data-id="element-11" data-mp="56l3b4umzkw" />
        <Testimonials data-id="element-12" data-mp="7ssnarqpf34" />
        <Guarantee data-id="element-13" data-mp="2zld43f9knpe6" />
        <WhyWeCreated data-id="element-14" data-mp="2zm4yimrfnh2v" />
        <Faq data-id="element-15" data-mp="2zmo5j8fjol24" />
        <FinalCta data-id="element-16" data-mp="2zn6aquk6q9m6" />
      </main>
      <Footer data-id="element-17" data-mp="33mf1rrnubte1" />
      <FloatingCta data-id="element-18" data-mp="33lwyib2rgewm" />
      <PurchasePopup data-id="element-19" data-mp="33nggc642ey0i" />
    </div>;
}